module.exports = __webpack_public_path__ + "img/11.daee7d8f.jpg";